// Keep the product-page sticky ATC permanently available.
document.addEventListener("DOMContentLoaded", function() {
  const stickyATC = document.querySelector('.m-sticky-atc');
  if (stickyATC) stickyATC.classList.add('m-sticky-atc--visible');

  function syncStickyVariantLabel(control) {
    var source = control;
    if (control && control.tagName === 'SELECT') {
      source = control.options[control.selectedIndex];
    }
    var label = source && source.getAttribute('data-variant-label');
    if (label && label.trim().toLowerCase() === 'default title') label = '';
    var stickyLabel = document.querySelector('.m-sticky-variant-label');
    var productSize = stickyLabel && stickyLabel.getAttribute('data-product-size');
    if (stickyLabel && (productSize || label)) {
      stickyLabel.textContent = productSize || label;
    }
  }

  document.addEventListener('change', function(event) {
    if (event.target.matches('.variant-pil-selcetor, .varinat-slector')) {
      syncStickyVariantLabel(event.target);
    }
  });
});


// main product page variant cards -----------
document.addEventListener('DOMContentLoaded', function(){
    let currentVariant = document.querySelectorAll('.variant-card-label');

    currentVariant.forEach(ele => { 
        ele.addEventListener("click", function(){
            var variantPrice = ele.getAttribute('data-variant-price');
            var variantId = ele.getAttribute('data-variant-id');
            var variantQuantity = parseInt(ele.getAttribute('data-variant-quantity')) || 0;
            var stickyAtcId = document.querySelector(".m-variant-input");
            var moneyContainers = document.querySelectorAll('.m-variant-price');
            var addToCartButtons = document.querySelectorAll('.m_atc_main_form .add-cart-btn');
            var ctMainElements = document.querySelectorAll('.ct_main.ct_left_main_m.ct_s_btn_main');
            var stickyVariantLabel = document.querySelector('.m-sticky-variant-label');
            var variantTitle = ele.querySelector('.variant-title');
            
            if (moneyContainers.length > 0) { 
                moneyContainers.forEach(function(container) {
                    container.innerHTML = variantPrice;
                });
            }
            if (stickyAtcId) stickyAtcId.value = variantId;
            if (stickyVariantLabel && variantTitle) {
                var fallbackVariantTitle = variantTitle.textContent.trim();
                if (fallbackVariantTitle.toLowerCase() === 'default title') fallbackVariantTitle = '';
                stickyVariantLabel.textContent = stickyVariantLabel.getAttribute('data-product-size') || fallbackVariantTitle;
            }

            // Update all add to cart buttons state and text
            if (addToCartButtons.length > 0) {
                addToCartButtons.forEach(function(button) {
                    var label = button.querySelector('.m-atc-main-txt, .m-sticky-atc-label');
                    var separator = button.querySelector('.m-sticky-atc-separator');
                    var buttonPrice = button.querySelector('.m-sticky-atc-button-price');
                    if (variantQuantity > 0) {
                        button.disabled = false;
                        if (label) label.textContent = 'Add to cart';
                        if (separator) separator.hidden = false;
                        if (buttonPrice) buttonPrice.hidden = false;
                    } else {
                        button.disabled = true;
                        if (label) label.textContent = 'Out Of Stock';
                        if (separator) separator.hidden = true;
                        if (buttonPrice) buttonPrice.hidden = true;
                    }
                });
            }

            // Show/hide ct_main elements based on inventory
            if (ctMainElements.length > 0) {
                ctMainElements.forEach(function(element) {
                    if (variantQuantity > 0) {
                        element.style.display = 'none'; // Hide when product available
                    } else {
                        element.style.display = 'block'; // Show when product out of stock
                    }
                });
            }


            // Show Variant-specific gallery
            var galleryItems = document.querySelectorAll('.m_productGallery .product-colm');

            if (galleryItems.length > 0) {
                galleryItems.forEach(function(item) {
                    var itemVariantId = item.getAttribute('data-variant-id');

                    // Show only matching variant images, hide others
                    if (itemVariantId === variantId) {
                      item.classList.add('activeGallery');
                      item.classList.remove('hiddenGallery');
                    } else {
                      item.classList.remove('activeGallery');
                      item.classList.add('hiddenGallery');
                    }

                });
            }

        });
    });
});

// Sibling sizes are separate Shopify products, so selecting one requires a full
// document navigation. Prefetch their documents while the browser is idle to
// avoid waiting for Shopify's HTML response after the customer taps a size.
(function () {
  var prefetchedUrls = Object.create(null);

  function canPrefetch() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return !(connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || "")));
  }

  function prefetchUrl(url) {
    if (!url || prefetchedUrls[url] || !canPrefetch()) return;
    prefetchedUrls[url] = true;

    var link = document.createElement("link");
    link.rel = "prefetch";
    link.as = "document";
    link.href = url;
    document.head.appendChild(link);
  }

  function prefetchSiblingPages() {
    document.querySelectorAll('.m-sibling-selector--pdp a.m-sibling-pill[href]').forEach(function (pill) {
      prefetchUrl(pill.href);
    });
  }

  function schedulePrefetch() {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(prefetchSiblingPages, { timeout: 1200 });
    } else {
      window.setTimeout(prefetchSiblingPages, 250);
    }
  }

  document.addEventListener("pointerover", function (event) {
    var pill = event.target.closest && event.target.closest('.m-sibling-selector--pdp a.m-sibling-pill[href]');
    if (pill) prefetchUrl(pill.href);
  }, { passive: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedulePrefetch, { once: true });
  } else {
    schedulePrefetch();
  }
})();

// Sticky PDP quantity control. Once the selected variant is in the cart, the
// sticky ATC button becomes a compact minus / quantity / plus stepper.
(function () {
  var cartRequest = null;

  function fetchCart() {
    if (cartRequest) return cartRequest;
    cartRequest = fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store",
      headers: { Accept: "application/json" }
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Cart request failed");
        return response.json();
      })
      .finally(function () {
        cartRequest = null;
      });
    return cartRequest;
  }

  function getVariantId(form) {
    if (!form) return "";
    var field = form.querySelector('input[name="id"]:checked, select[name="id"], .m-variant-input, .m_product_varaint_input, input[name="id"]');
    return field && field.value ? String(field.value) : "";
  }

  function findLine(cart, variantId) {
    if (!cart || !Array.isArray(cart.items) || !variantId) return null;
    return cart.items.find(function (item) {
      return String(item.variant_id || item.id) === String(variantId);
    }) || null;
  }

  function buildStepper(bar, button) {
    var existing = bar.querySelector("[data-sticky-qty]");
    if (existing) return existing;

    var stepper = document.createElement("div");
    stepper.className = "m-sticky-qty";
    stepper.hidden = true;
    stepper.setAttribute("data-sticky-qty", "");
    stepper.setAttribute("aria-label", "Cart quantity");
    stepper.innerHTML =
      '<button type="button" class="m-sticky-qty__button" data-sticky-qty-minus aria-label="Decrease quantity">&minus;</button>' +
      '<span class="m-sticky-qty__value" data-sticky-qty-value aria-live="polite">1</span>' +
      '<button type="button" class="m-sticky-qty__button" data-sticky-qty-plus aria-label="Increase quantity">+</button>';

    var action = button.closest(".m-sticky-atc-action");
    (action || button.parentNode).appendChild(stepper);
    return stepper;
  }

  function initStickyQuantity(bar) {
    if (bar.dataset.stickyQuantityReady === "true") return;
    var button = bar.querySelector(".m-sticky-atc-btn, .pdp-v2__sticky-btn");
    var form = bar.closest("form");
    if (!button || !form) return;

    bar.dataset.stickyQuantityReady = "true";
    var stepper = buildStepper(bar, button);
    var value = stepper.querySelector("[data-sticky-qty-value]");
    var working = false;
    var currentLine = null;

    function render(cart) {
      currentLine = findLine(cart, getVariantId(form));
      var quantity = currentLine ? currentLine.quantity : 0;
      button.hidden = quantity > 0;
      stepper.hidden = quantity < 1;
      value.textContent = String(quantity || 1);
      stepper.dataset.lineKey = currentLine ? currentLine.key : "";
      stepper.dataset.quantity = String(quantity);
    }

    function sync() {
      return fetchCart().then(render).catch(function () {});
    }

    function changeQuantity(nextQuantity) {
      if (working || !currentLine) return;
      working = true;
      // Reflect the intent right away; render() reconciles with the real cart
      // once the request resolves (or sync() restores truth if it fails).
      value.textContent = String(Math.max(0, nextQuantity) || 1);
      stepper.classList.add("is-loading");
      stepper.querySelectorAll("button").forEach(function (control) { control.disabled = true; });

      var cartDrawer = document.querySelector("cart-drawer");
      var sections = ["cart-drawer", "cart-icon-bubble"];
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
        sections = cartDrawer.getSectionsToRender().map(function (section) { return section.id; });
      }

      fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({
          id: currentLine.key,
          quantity: Math.max(0, nextQuantity),
          sections: sections,
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Quantity update failed");
          return response.json();
        })
        .then(function (cart) {
          render(cart);
          if (cartDrawer && cart.sections && typeof cartDrawer.renderContents === "function") {
            cartDrawer.renderContents(cart);
          }
          document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
        })
        .catch(sync)
        .finally(function () {
          working = false;
          stepper.classList.remove("is-loading");
          stepper.querySelectorAll("button").forEach(function (control) { control.disabled = false; });
        });
    }

    stepper.addEventListener("click", function (event) {
      var control = event.target.closest("button");
      if (!control) return;
      var quantity = parseInt(stepper.dataset.quantity, 10) || 0;
      changeQuantity(quantity + (control.hasAttribute("data-sticky-qty-plus") ? 1 : -1));
    });

    form.addEventListener("change", function (event) {
      if (event.target.matches('[name="id"], .variant-card-input, .variant-pil-selcetor, .varinat-slector')) sync();
    });
    document.addEventListener("theme:cart:added", sync);
    document.addEventListener("cart:updated", function (event) {
      var cart = event.detail && event.detail.cart;
      if (cart && Array.isArray(cart.items)) render(cart);
      else sync();
    });
    sync();
  }

  function initAllStickyQuantities() {
    document.querySelectorAll(".m-sticky-atc").forEach(initStickyQuantity);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllStickyQuantities, { once: true });
  } else {
    initAllStickyQuantities();
  }
})();



// Keep selling price, compare-at price, and discount percentage in one state.
function updateGridCardPrice(card, price, comparePrice, discountPercentage) {
  if (!card || !price) return;

  const priceWrap = card.querySelector(".m-card-price-wrap, .m-pro-grid-price, .price-p");
  if (!priceWrap) return;

  const hasDiscount = Boolean(comparePrice && discountPercentage);
  const priceRow = priceWrap.closest(".m-card-price-row");
  let html = '<span class="price-new"> ' + price + "</span>";
  if (hasDiscount) {
    html += ' <span class="old-price">' + comparePrice + "</span>";
    if (!priceRow) {
      html += ' <span class="off-price">' + discountPercentage + "% OFF</span>";
    }
  }
  priceWrap.innerHTML = html;

  if (!priceRow) return;

  let offPrice = null;
  for (let i = 0; i < priceRow.children.length; i++) {
    if (priceRow.children[i].classList.contains("off-price")) {
      offPrice = priceRow.children[i];
      break;
    }
  }

  if (!hasDiscount) {
    if (offPrice) offPrice.remove();
    return;
  }

  if (!offPrice) {
    offPrice = document.createElement("span");
    offPrice.className = "off-price";
    priceRow.appendChild(offPrice);
  }
  offPrice.textContent = discountPercentage + "% OFF";
}

// Pixels the marquee travels per second. Constant speed means a short label and
// a long label scroll at the same visual pace instead of long ones racing.
const M_VARIANT_BADGE_SPEED = 30;

// Fallback gap if --m-variant-badge-gap is missing or unreadable.
const M_VARIANT_BADGE_GAP_FALLBACK = 24;

// The gap is declared in CSS (and narrowed at the mobile breakpoint), so read it
// back rather than hardcoding it — the travel distance must equal label + the
// gap that is ACTUALLY rendered, or the two copies drift and the loop shows a
// seam.
function getVariantBadgeGap(badge) {
  const raw = getComputedStyle(badge).getPropertyValue("--m-variant-badge-gap");
  const gap = parseFloat(raw);
  return isNaN(gap) ? M_VARIANT_BADGE_GAP_FALLBACK : gap;
}

// Renders the badge as a seamless marquee when the label overflows.
//
// The track holds TWO copies of the label. The animation translates the track
// by exactly one copy's width (label + gap), so the moment copy #1 scrolls out
// on the left, copy #2 is sitting exactly where copy #1 started — the loop
// restart is invisible and there is never a blank stretch inside the pill.
// When the label fits, we render a single centered copy and no animation.
function setVariantBadgeText(badge, text) {
  if (!badge) return;

  const label = (text || "").trim();

  // Nothing to show — clear it out and bail.
  if (!label) {
    badge.dataset.badgeLabel = "";
    badge.classList.remove("is-overflowing");
    badge.style.removeProperty("--m-variant-badge-shift");
    badge.style.removeProperty("--m-variant-badge-duration");
    badge.textContent = "";
    return;
  }

  // Rebuild only when the label actually changed. Re-measuring an unchanged
  // badge restarts the CSS animation from 0% (the visible "stutter") and, on a
  // resize/observer storm, wipes the pill for a frame (the visible "blank").
  if (badge.dataset.badgeLabel === label && badge.querySelector(".m_product_variant_heading_track")) {
    measureVariantBadge(badge);
    return;
  }

  badge.dataset.badgeLabel = label;
  badge.classList.remove("is-overflowing");
  badge.style.removeProperty("--m-variant-badge-shift");
  badge.style.removeProperty("--m-variant-badge-duration");
  badge.textContent = "";

  const track = document.createElement("span");
  track.className = "m_product_variant_heading_track";

  const primary = document.createElement("span");
  primary.className = "m_product_variant_heading_text";
  primary.textContent = label;

  // Second copy is purely decorative filler for the seamless wrap-around.
  const clone = document.createElement("span");
  clone.className = "m_product_variant_heading_text is-clone";
  clone.textContent = label;
  clone.setAttribute("aria-hidden", "true");

  track.appendChild(primary);
  track.appendChild(clone);
  badge.appendChild(track);

  measureVariantBadge(badge);
}

// Decides whether the badge overflows and, if so, sets the exact travel
// distance and a duration proportional to it.
function measureVariantBadge(badge) {
  const primary = badge.querySelector(".m_product_variant_heading_text");
  if (!primary) return;

  requestAnimationFrame(function () {
    // getBoundingClientRect gives sub-pixel width; rounding it (as scrollWidth
    // does) is what left a sliver of the last glyph clipped.
    const labelWidth = primary.getBoundingClientRect().width;
    const badgeWidth = badge.clientWidth;
    if (!labelWidth || !badgeWidth) return;

    // 1px tolerance absorbs sub-pixel rounding so a label that exactly fits
    // does not get flagged as overflowing and scroll pointlessly.
    const hasOverflow = labelWidth > badgeWidth + 1;

    if (hasOverflow) {
      // Travel = one full copy of the label plus the gap that follows it. This
      // is what lands copy #2 exactly on copy #1's starting mark.
      const shift = labelWidth + getVariantBadgeGap(badge);
      const duration = Math.max(shift / M_VARIANT_BADGE_SPEED, 3);
      badge.style.setProperty("--m-variant-badge-shift", shift + "px");
      badge.style.setProperty("--m-variant-badge-duration", duration.toFixed(2) + "s");
    } else {
      badge.style.removeProperty("--m-variant-badge-shift");
      badge.style.removeProperty("--m-variant-badge-duration");
    }

    badge.classList.toggle("is-overflowing", hasOverflow);
  });
}

// Exposed so sections with their own variant-switch code (e.g.
// lightning-sale-carousel) build the marquee markup through this one
// implementation instead of re-rolling it and drifting out of sync with the CSS.
window.mSetVariantBadgeText = setVariantBadgeText;

function refreshVariantBadge(badge) {
  if (!badge) return;
  const existing = badge.querySelector(".m_product_variant_heading_text");
  setVariantBadgeText(badge, existing ? existing.textContent : badge.textContent);
}

function initVariantBadges(root) {
  const scope = root || document;
  if (scope.nodeType === 1 && scope.matches && scope.matches(".m_product_variant_heading")) {
    refreshVariantBadge(scope);
  }
  scope.querySelectorAll(".m_product_variant_heading").forEach(refreshVariantBadge);
}

document.addEventListener("DOMContentLoaded", function () {
  initVariantBadges(document);
  window.mInitVariantBadges = initVariantBadges;

  if (window.MutationObserver && document.body) {
    let badgePass = null;

    const badgeObserver = new MutationObserver(function (mutations) {
      // Ignore our own writes. setVariantBadgeText appends the track/label spans,
      // which the observer would otherwise report back to us as "new nodes" —
      // re-triggering a refresh in an endless loop that thrashed the animation.
      const pending = [];
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.closest && node.closest(".m_product_variant_heading")) return;
          pending.push(node);
        });
      });

      if (!pending.length || badgePass) return;

      // Coalesce a burst of DOM insertions (Slick cloning slides, quick-add
      // injecting a card) into one measure pass on the next frame.
      badgePass = requestAnimationFrame(function () {
        badgePass = null;
        pending.forEach(initVariantBadges);
      });
    });

    badgeObserver.observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener("load", function () {
    initVariantBadges(document);
  });

  let badgeResize = null;
  window.addEventListener("resize", function () {
    clearTimeout(badgeResize);
    badgeResize = setTimeout(function () {
      // Widths changed, so the cached measurement is stale even though the
      // labels are unchanged. Re-measure without rebuilding the markup.
      document.querySelectorAll(".m_product_variant_heading").forEach(measureVariantBadge);
    }, 150);
  });
});

// FUNCTION: Update variant info inside a product card
function updateVariant(card, dropdown) {
  const variantId = dropdown.value;
  // Try to find option reliably by value (bfcache may restore value but not selectedIndex correctly)
  let option = dropdown.options[dropdown.selectedIndex];
  if (!option || option.value !== variantId) {
    // find option by value as fallback
    for (let i = 0; i < dropdown.options.length; i++) {
      if (dropdown.options[i].value === variantId) {
        option = dropdown.options[i];
        break;
      }
    }
  }

  if (!option) return; // Safety check

  const variantPrice = option.getAttribute("data-product-price") || option.dataset.productPrice || "";
  const variantComparePrice = option.getAttribute("data-product-compare-price") || option.dataset.productComparePrice || "";
  const variantDiscountPercentage = option.getAttribute("data-product-discount-percentage") || option.dataset.productDiscountPercentage || "";
  const variantTitle = option.getAttribute("data-product-title") || option.dataset.productTitle || "";
  const variantImage = option.getAttribute("data-variant-feature-img") || option.dataset.variantFeatureImg || "";
  const variantSrcset = option.getAttribute("data-variant-srcset") || option.dataset.variantSrcset || ""; // *** ADDED
  const variantUrl = option.getAttribute("data-variant-url") || option.dataset.variantUrl || "";
  const variantQuantity = option.getAttribute("data-variant-quantity") || option.dataset.variantQuantity || "-1";

  // Update hidden input
  const hiddenInput = card.querySelector(".m_product_varaint_input");
  if (hiddenInput) hiddenInput.value = variantId;

  const gridCart = card.querySelector("[data-grid-cart]");
  if (gridCart) {
    gridCart.dataset.variantId = variantId;
    gridCart.dataset.variantQuantity = variantQuantity;
  }

  // Update title
  const titleBox = card.querySelector(".m_product_variant_heading");
  if (titleBox) setVariantBadgeText(titleBox, variantTitle || "");

  // Update selling price and clear/rebuild sale values as one atomic state.
  updateGridCardPrice(card, variantPrice || "—", variantComparePrice, variantDiscountPercentage);

  // Update image
  const imageContainer = card.querySelector(".m-product-card-img-home"); 
  if (imageContainer) {
    // If it's an <img>
    if (imageContainer.tagName && imageContainer.tagName.toLowerCase() === 'img') {
      // set src, data-src (for lazy loaders) and srcset if available
      if (variantImage) {
        imageContainer.src = variantImage;
        imageContainer.setAttribute('src', variantImage);
        imageContainer.dataset.src = variantImage; // helps some lazy libraries
      } else {
        // fallback to a default stored on the element or existing src
        const fallback = imageContainer.dataset.default || imageContainer.getAttribute('data-default') || imageContainer.getAttribute('src') || "";
        imageContainer.src = fallback;
        imageContainer.setAttribute('src', fallback);
        imageContainer.dataset.src = fallback;
      }

      if (variantSrcset) {
        imageContainer.srcset = variantSrcset;
        imageContainer.setAttribute('srcset', variantSrcset);
        imageContainer.dataset.srcset = variantSrcset;
      } else {
        const fallbackSet = imageContainer.dataset.defaultSrcset || imageContainer.getAttribute('data-default-srcset') || imageContainer.getAttribute('srcset') || "";
        if (fallbackSet) {
          imageContainer.srcset = fallbackSet;
          imageContainer.setAttribute('srcset', fallbackSet);
          imageContainer.dataset.srcset = fallbackSet;
        }
      }
    } else {
      // If it's not an <img> (maybe a div with background), set background-image
      if (variantImage) {
        imageContainer.style.backgroundImage = 'url("' + variantImage + '")';
        imageContainer.dataset.bg = variantImage;
      } else {
        const fallback = imageContainer.dataset.default || imageContainer.getAttribute('data-default') || "";
        if (fallback) imageContainer.style.backgroundImage = 'url("' + fallback + '")';
      }
    }
  }

  // Update variant url on every card link (image link + title link) so the
  // product title redirects to the selected variant's URL.
  if (variantUrl) {
    const variantLinks = card.querySelectorAll(
      ".m-product-redirect-link, .prd-h-img, .m-product-title-link"
    );
    variantLinks.forEach(function (l) {
      l.href = variantUrl;
    });
  }
}

// FUNCTION: attach logic to each product card
function attachVariantLogic(card) {
  const dropdown = card.querySelector(".m_variant_select");
  if (!dropdown) return;

  // *** CHANGED: make idempotent (avoid double listeners)
  if (card.dataset.variantLogicAttached === "true") {
    // ensure UI sync in case browser restored select value
    updateVariant(card, dropdown);
    return;
  }

  // Trigger initial update
  updateVariant(card, dropdown);

  // Update on change
  dropdown.addEventListener("change", function () {
    updateVariant(card, dropdown);
  });

  card.dataset.variantLogicAttached = "true"; // *** CHANGED
}

// INITIAL RUN (for already loaded products)
function initVariants() {
  document.querySelectorAll(".home-cat-iteam, .product-bx").forEach(card => {
    attachVariantLogic(card);
  });
}

document.addEventListener("DOMContentLoaded", initVariants);

// *** ADDED: pageshow handler to fix back-button / bfcache issue
window.addEventListener('pageshow', function (event) {
  // slight async to let browser restore form state fully
  setTimeout(() => {
    document.querySelectorAll(".home-cat-iteam, .product-bx").forEach(card => {
      const dropdown = card.querySelector(".m_variant_select");
      if (dropdown) {
        // re-sync UI to the select's current value (browser may have restored it)
        updateVariant(card, dropdown);
      }
      // ensure listeners are attached (if page restore skipped script init)
      attachVariantLogic(card);
    });
  }, 30); // 30ms usually enough; increase to 100ms if still flaky
});

// ============================
// ✅ MUTATION OBSERVER SETUP
// ============================

const observer = new MutationObserver(function (mutations) {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {

      // If a new product card is added
      if (
        node.classList &&
        (node.classList.contains("home-cat-iteam") ||
         node.classList.contains("product-bx"))
      ) {
        attachVariantLogic(node);
      }

      // If added node contains product cards inside
      if (node.querySelectorAll) {
        node.querySelectorAll(".home-cat-iteam, .product-bx").forEach(card => {
          attachVariantLogic(card);
        });
      }

    });
  });
});

// Observe entire body for AJAX-loaded products
observer.observe(document.body, {
  childList: true,
  subtree: true
});


//cart-drawer add visibility set 
document.addEventListener("DOMContentLoaded", function () {
  const drawer = document.querySelector(".hs-popup-cart-sp-load");
  if (!drawer) return;

  // Helper to sync visibility with class
  function syncVisibility() {
    if (drawer.classList.contains("hs-active")) {
      drawer.style.setProperty("visibility", "visible", "important");
    } else {
      drawer.style.setProperty("visibility", "hidden", "important");
    }
  }

  // Run once on load
  syncVisibility();

  // Watch for class changes (theme JS jab hs-active add/remove karega)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === "class") {
        syncVisibility();
      }
    });
  });

  observer.observe(drawer, { attributes: true });
});
// Format Judge.me preview badges on grid cards: round rating to 1 decimal,
// hide pill when there are no reviews. Runs on load and re-runs when new cards
// are appended (infinite-scroll / pagination / dynamic sections).
document.addEventListener('DOMContentLoaded', function () {
  function formatJdgmBadges() {
    const widgets = document.querySelectorAll('.product-bx .jdgm-widget.jdgm-preview-badge');
    widgets.forEach(function (widget) {
      const inner = widget.querySelector('.jdgm-prev-badge');
      const reviews = inner ? parseInt(inner.getAttribute('data-number-of-reviews') || '0', 10) : 0;

      if (!inner || isNaN(reviews) || reviews <= 0) {
        widget.classList.add('is-empty');
        return;
      }
      widget.classList.remove('is-empty');

      const rawRating = parseFloat(inner.getAttribute('data-average-rating'));
      if (!isNaN(rawRating)) {
        inner.setAttribute('data-rating-display', rawRating.toFixed(1));
      }
    });
  }

  let scheduled = false;
  function scheduleFormat() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      scheduled = false;
      formatJdgmBadges();
    });
  }

  formatJdgmBadges();

  const mo = new MutationObserver(function (mutations) {
    for (let i = 0; i < mutations.length; i++) {
      const m = mutations[i];
      if (m.addedNodes && m.addedNodes.length) {
        scheduleFormat();
        return;
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
});


/* =============================================================================
   Sibling switcher — collection card
   The card snippet renders a <select class="m-sibling-select">; each <option>
   carries the data needed to re-skin the surrounding card to a different
   sibling product (image / title / price / url / ATC variant id).

   Coexists with the older `attachVariantLogic` (which keys off
   `.m_variant_select`) so inline cards in legacy sections like bestsellers
   keep working unchanged.
   ============================================================================= */
(function () {
  function getSiblingCard(select) {
    return (
      select.closest(".m-product-card-wrapper") ||
      select.closest(".product-bx") ||
      select.closest(".prduct-filter") ||
      select.closest("form")
    );
  }

  function applySiblingSelection(card, option) {
    if (!card || !option) return;

    var data = option.dataset;

    // 1) Hidden ATC input — /cart/add accepts any valid variant id, so
    //    swapping in the sibling's variant id is sufficient (no need to
    //    re-render the form action).
    var hiddenInput = card.querySelector(".m_product_varaint_input");
    if (hiddenInput && data.productVariantId) {
      hiddenInput.value = data.productVariantId;
    }

    var gridCart = card.querySelector("[data-grid-cart]");
    if (gridCart && data.productVariantId) {
      gridCart.dataset.variantId = data.productVariantId;
      gridCart.dataset.variantQuantity = data.productVariantQuantity || "-1";
    }

    // 2) Card image — update both src and the lazysizes data-* keys so the
    //    lazy loader (loaded globally in theme.liquid) doesn't restore the
    //    previous image when it processes the element.
    var img = card.querySelector(".m-product-card-img-home, .prd-h-img img");
    if (img && data.productImage) {
      img.src = data.productImage;
      img.setAttribute("src", data.productImage);
      img.dataset.src = data.productImage;
      if (data.productImageSrcset) {
        img.srcset = data.productImageSrcset;
        img.setAttribute("srcset", data.productImageSrcset);
        img.dataset.srcset = data.productImageSrcset;
      }
      if (data.productTitle) img.alt = data.productTitle;
    }

    // 3) Card links — point both the image link and the title link at the
    //    selected sibling so clicking the card OR the title lands the customer
    //    on the right PDP.
    if (data.productUrl) {
      var links = card.querySelectorAll(
        ".m-product-redirect-link, .prd-h-img, .m-product-title-link"
      );
      for (var li = 0; li < links.length; li++) {
        links[li].href = data.productUrl;
      }
    }

    // 4) Title + size badge. The size badge (.m_product_variant_heading) shows
    //    the size_of_product metafield value (e.g. "65 g", "120 ml") so it
    //    matches the current dropdown selection.
    //
    //    Write the title text into the deepest text holder we can find WITHOUT
    //    destroying the redirect anchor. Cards differ in markup:
    //      - card-product:        .product-heading > a > span.title
    //      - product-card / best: .product-heading > a.m-product-title-link
    //      - legacy inline:       .product-heading (plain text, no link)
    //    Targeting the <a> (or its inner .title span) with textContent keeps the
    //    anchor alive; only the bare-heading fallback writes to the <h4>/<p>.
    if (data.productTitle) {
      var titleEl =
        card.querySelector(".product-heading .m-product-title-link .title") ||
        card.querySelector(".product-heading .title") ||
        card.querySelector(".product-heading .m-product-title-link") ||
        card.querySelector(".product-heading");
      if (titleEl) titleEl.textContent = data.productTitle;
    }

    var subtitle = card.querySelector(".m_product_variant_heading");
    if (subtitle) {
      var label = data.productSize || data.productVariantTitle || "";
      setVariantBadgeText(subtitle, label);
    }

    // 5) Price block — update all sale state together so stale compare and
    //    percentage values cannot survive a non-sale sibling selection.
    updateGridCardPrice(
      card,
      data.productPrice,
      data.productComparePrice,
      data.productDiscountPercentage
    );

    // 6) ATC button availability state — toggle BOTH the disabled attribute
    //    and the label. Updating only the attribute left the server-rendered
    //    text behind, so a sold-out card kept saying "Sold out" after the
    //    customer switched to an in-stock sibling (and vice-versa).
    var addBtn = card.querySelector(".add-cart-btn");
    if (addBtn) {
      var available = data.productAvailable === "true";
      var strings = window.variantStrings || {};
      var addLabel = strings.addToCart || "Add to cart";
      var soldLabel = strings.soldOut || "Sold out";
      if (available) {
        addBtn.removeAttribute("disabled");
      } else {
        addBtn.setAttribute("disabled", "disabled");
      }
      // Write the label to the inner text span when one exists (Dawn-style
      // buttons), otherwise straight to the button — the grid card buttons
      // hold plain text, so textContent is safe and won't wipe an icon.
      var labelTarget =
        addBtn.querySelector(
          "span:not(.sold-out-message):not(.loading-overlay__spinner)"
        ) || addBtn;
      labelTarget.textContent = available ? addLabel : soldLabel;
    }
  }

  function syncSiblingSelect(select) {
    if (!select || !select.options) return;

    var option = select.options[select.selectedIndex];
    if (!option) return;

    var card = getSiblingCard(select);
    if (!card) return;

    applySiblingSelection(card, option);
  }

  function initSiblingCards(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var selects = scope.querySelectorAll(".m-sibling-selector--card .m-sibling-select");
    for (var i = 0; i < selects.length; i++) {
      syncSiblingSelect(selects[i]);
    }
  }

  function handleSiblingSelectEvent(event) {
    var select = event.target;
    if (!select.classList || !select.classList.contains("m-sibling-select")) return;
    syncSiblingSelect(select);
  }

  // Delegated listener — works for cards rendered server-side as well as
  // those AJAX-injected later (infinite scroll, facet refresh, etc.).
  document.addEventListener("change", handleSiblingSelectEvent, true);
  document.addEventListener("input", handleSiblingSelectEvent, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initSiblingCards(document);
    });
  } else {
    initSiblingCards(document);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes || [];
      for (var j = 0; j < nodes.length; j++) {
        if (nodes[j].nodeType === 1) initSiblingCards(nodes[j]);
      }
    }
  });

  function observeSiblingCards() {
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeSiblingCards);
  } else {
    observeSiblingCards();
  }
})();


/* =============================================================================
   Sibling switcher — PDP horizontal scroll buttons
   Shows small rounded prev/next buttons only when the pill track overflows.
   ============================================================================= */
(function () {
  var START_TOLERANCE = 4;

  function initSiblingScroller(scroller) {
    var track = scroller.querySelector(".m-sibling-selector__track");
    var prev = scroller.querySelector(".m-sibling-selector__nav--prev");
    var next = scroller.querySelector(".m-sibling-selector__nav--next");
    if (!track || !prev || !next) return;

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 2) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }
      if (track.scrollLeft > 0 && track.scrollLeft <= START_TOLERANCE) {
        track.scrollLeft = 0;
      }
      prev.hidden = track.scrollLeft <= START_TOLERANCE;
      next.hidden = track.scrollLeft >= maxScroll - 1;
    }

    function step(direction) {
      track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: "smooth" });
    }

    // Preserve the true start position when the active card is already visible.
    // Only move the row by the minimum amount needed to reveal a clipped card.
    function revealActive() {
      var active = track.querySelector(".m-sibling-pill.is-active");
      if (!active) return;
      var trackRect = track.getBoundingClientRect();
      var activeRect = active.getBoundingClientRect();
      if (activeRect.left < trackRect.left) {
        track.scrollLeft += activeRect.left - trackRect.left;
      } else if (activeRect.right > trackRect.right) {
        track.scrollLeft += activeRect.right - trackRect.right;
      } else if (track.scrollLeft <= START_TOLERANCE) {
        track.scrollLeft = 0;
      }
    }

    prev.addEventListener("click", function () { step(-1); });
    next.addEventListener("click", function () { step(1); });
    track.addEventListener("scroll", update);
    window.addEventListener("resize", update);
    window.addEventListener("pageshow", update);
    if (typeof ResizeObserver !== "undefined") {
      try { new ResizeObserver(update).observe(track); } catch (error) {}
    }
    revealActive();
    update();
    window.requestAnimationFrame(update);
    window.setTimeout(update, 150);
  }

  function initAll() {
    var scrollers = document.querySelectorAll(
      ".m-sibling-selector--pdp .m-sibling-selector__scroller"
    );
    for (var i = 0; i < scrollers.length; i++) {
      initSiblingScroller(scrollers[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();


/* PDP ATC fallback: resolve the sibling product variant before add. */
(function () {
  function isSiblingPdp() {
    return !!document.querySelector(".m-sibling-selector--pdp");
  }

  function getProductJsonUrl() {
    var canonical = document.querySelector('link[rel="canonical"]');
    var path = canonical
      ? new URL(canonical.href, window.location.origin).pathname
      : window.location.pathname;

    path = path.replace(/\/$/, "");
    return path + ".js";
  }

  function formSnapshot(form, button) {
    var data = [];
    if (form) {
      new FormData(form).forEach(function (value, key) {
        data.push({ name: key, value: value });
      });
    }

    return {
      action: form && form.getAttribute("action"),
      method: form && form.getAttribute("method"),
      classes: form && form.className,
      dataType: form && form.getAttribute("data-type"),
      buttonClasses: button && button.className,
      formData: data
    };
  }

  function getCartComponent() {
    return document.querySelector("cart-drawer") || document.querySelector("cart-notification");
  }

  function resolveVariantId(form, formData) {
    var existingId = formData.get("id");
    if (existingId) return Promise.resolve(String(existingId));

    var field = form && form.querySelector(
      '.m_product_varaint_input, input[name="id"]:checked, select[name="id"], input[name="id"]'
    );
    if (field && field.value) {
      formData.set("id", field.value);
      return Promise.resolve(field.value);
    }

    var activeSibling = document.querySelector(".m-sibling-selector--pdp .m-sibling-pill.is-active");
    if (activeSibling && activeSibling.dataset.productVariantId) {
      formData.set("id", activeSibling.dataset.productVariantId);
      return Promise.resolve(activeSibling.dataset.productVariantId);
    }

    return fetch(getProductJsonUrl(), {
      method: "GET",
      credentials: "same-origin",
      cache: "no-store",
      headers: { Accept: "application/json" }
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Product JSON request failed: " + response.status);
        return response.json();
      })
      .then(function (productJson) {
        var variants = productJson && productJson.variants ? productJson.variants : [];
        var variant = variants.find(function (item) {
          return item.available;
        }) || variants[0];

        if (!variant || !variant.id) return null;

        formData.set("id", String(variant.id));
        console.log("[PDP ATC debug] fallback resolved variant from product JSON", variant);
        return String(variant.id);
      })
      .catch(function (error) {
        console.error("[PDP ATC debug] fallback could not resolve variant from product JSON", error);
        return null;
      });
  }

  function updateFallbackCartUi(cartJson) {
    var cartComponent = getCartComponent();
    if (cartComponent && cartJson && cartJson.sections && cartComponent.renderContents) {
      cartComponent.renderContents(cartJson);
      return;
    }

    return fetch("/cart.js", {
      method: "GET",
      credentials: "same-origin",
      cache: "no-store"
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var count = document.getElementById("cart_items_count");
        if (count && typeof cart.item_count !== "undefined") {
          count.textContent = cart.item_count;
        }

        if (typeof window.HS_SLIDE_CART_UPDATED === "function") {
          window.HS_SLIDE_CART_UPDATED(cart);
        }
      });
  }

  function fallbackAddToCart(form, button) {
    if (!form || form.dataset.pdpAtcFallbackSubmitting === "true") return;

    form.dataset.pdpAtcFallbackSubmitting = "true";
    var formData = new FormData(form);

    resolveVariantId(form, formData)
      .then(function (variantId) {
        if (!variantId) {
          console.error("[PDP ATC debug] fallback stopped: missing variant id", formSnapshot(form, button));
          throw new Error("Missing variant id");
        }

        var cartComponent = getCartComponent();
        if (cartComponent && cartComponent.getSectionsToRender) {
          formData.set(
            "sections",
            cartComponent.getSectionsToRender().map(function (section) {
              return section.id;
            })
          );
          formData.set("sections_url", window.location.pathname);
          if (cartComponent.setActiveElement && document.activeElement) {
            cartComponent.setActiveElement(document.activeElement);
          }
        }

        console.log("[PDP ATC debug] fallback add started", formSnapshot(form, button));

        return fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: formData
        });
      })
      .then(function (response) {
        if (!response) return null;
        return response.json().then(function (json) {
          if (!response.ok || json.status) throw json;
          return json;
        });
      })
      .then(function (json) {
        if (!json) return;
        console.log("[PDP ATC debug] fallback add complete", json);
        return updateFallbackCartUi(json);
      })
      .catch(function (error) {
        if (error && error.message === "Missing variant id") return;
        console.error("[PDP ATC debug] fallback add failed", error);
      })
      .finally(function () {
        if (form) form.dataset.pdpAtcFallbackSubmitting = "false";
      });
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest && event.target.closest(".m_atc_main_form .add-cart-btn");
    if (!button || !isSiblingPdp()) return;

    var form = button.form || button.closest("form");
    console.log("[PDP ATC debug] click", formSnapshot(form, button));

    window.setTimeout(function () {
      console.log("[PDP ATC debug] click defaultPrevented after handlers:", event.defaultPrevented);
      if (!event.defaultPrevented) return;

      console.warn("[PDP ATC debug] click was prevented; running sibling PDP fallback add");
      fallbackAddToCart(form, button);
    }, 0);
  }, true);
})();
